'use strict';

var _require = require('./forschungsprojekt'),
    ForschungsprojektResource = _require.ForschungsprojektResource;

var _require2 = require('./publikation'),
    PublikationResource = _require2.PublikationResource;

var _require3 = require('./abstractPerson.js'),
    AbstractPersonResource = _require3.AbstractPersonResource;

var _require4 = require('./patent.js'),
    PatentResource = _require4.PatentResource;

var _require5 = require('./person.js'),
    PersonResource = _require5.PersonResource;

module.exports = {
  AbstractPersonResource: AbstractPersonResource,
  PersonResource: PersonResource,
  ForschungsprojektResource: ForschungsprojektResource,
  PatentResource: PatentResource,
  PublikationResource: PublikationResource
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/index.js
// module id = 450z
// module chunks = 0